class Controller {
  constructor(Events, $mdSidenav) {
    "ngInject";

    this.Events = Events;
    this.$mdSidenav = $mdSidenav;
  }

  $onInit() {
    const onOpenSidenavEvent = this.Events.eventsType.onOpenSidenav;
    const onOpenSidenav = () => this.$mdSidenav("main-sidenav").open();

    this.Events.on(onOpenSidenavEvent, onOpenSidenav);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/mainSidenav/mainSidenav.controller.js